/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../slices/auth/login/thunk';

// by msrusli, 05-Jun-2026: periodic token expiry monitor
const SESSION_CHECK_INTERVAL = 30000; // 30 seconds

const SessionMonitor = () => {
  const dispatch = useDispatch();
  const token = useSelector(state => state.Login?.user?.token);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    const checkSession = () => {
      try {
        const parts = token.split('.');
        if (parts.length !== 3) return;

        const payload = JSON.parse(atob(parts[1]));
        if (!payload.exp) return;

        const expiryMs = payload.exp * 1000;
        const now = Date.now();
        const timeLeft = expiryMs - now;

        // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
        // if (timeLeft <= 0) {
        //   sessionStorage.clear();
        //   dispatch(logoutUser());
        //   window.location.href = '/login';
        // }
        void timeLeft;
        // AUTO_LOGOUT_DISABLED_END
      } catch {
        // silently ignore decode errors
      }
    };

    intervalRef.current = setInterval(checkSession, SESSION_CHECK_INTERVAL);
    checkSession();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [dispatch, token]);

  return null;
};

export default SessionMonitor;
